import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["inputField"];
  }

  connect() {
    this.inputAttributes = this.inputFieldTargets
      .map(inputField => Array.from(inputField.attributes).map(item => [item.name, item.value]));

    this.cancelEdit();
  }

  editFields() {
    this.inputFieldTargets.forEach((inputField, index) => {
      let i = document.createElement("input");

      this.inputAttributes[index].forEach(attributes => i.setAttribute(...attributes));

      inputField.parentNode.replaceChild(i, inputField);
    });
  }

  cancelEdit() {
    this.inputFieldTargets.forEach((inputField, index) => {
      let d = document.createElement("div");

      this.inputAttributes[index].forEach((attributes) => {
        d.setAttribute(...attributes);

        if (attributes[0] === "value") d.textContent = attributes[1];
      });

      inputField.parentNode.replaceChild(d, inputField);
    });
  }
}
